import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listAction } from "../../network/store/action/BranchResponseAction";
import AddUpdateForm from "./add-update-form";
import {
  formUpdateStatus,
  updateFormInfo,
} from "../../redux/slice/formUpdateSlice";
import { updateMessage } from "../../redux/slice/toastSlice";
import StoreItem from "./store-item";
import { useNavigate } from "react-router-dom";
import { changeStatus } from "../../redux/slice/loaderSlice";

function Store() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const showRequestForm = useSelector(formUpdateStatus);
  // list of items
  const [resultList, setResultList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [searchVal, setSearchVal] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    dispatch(changeStatus(true));
    await dispatch(listAction(dispatch)).then((reponse) => {
      dispatch(changeStatus(false));
      if (reponse.result) {
        setResultList(reponse.result);
      }
    });
  };

  function handleSearchClick(e) {
    const searchTerm = e.target.value;
    setSearchVal(searchTerm);

    if (searchTerm === "") {
      setResultList(resultList);
      setFilterList([]);
    } else {
      const filterBySearch = resultList.filter((item) => {
        if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
          return item;
        }
      });
      setFilterList(filterBySearch);
    }
  }

  const navigateStoreCreationPage = () => {
    navigate("/scu");
  };

  const onSubmit = () => {
    dispatch(updateFormInfo({ displayForm: false, formData: {} }));
    dispatch(
      updateMessage({
        display: true,
        message: "Record updated",
      })
    );
    setResultList([]);
    setSearchVal("");
    setFilterList([]);

    loadData();
  };

  // const editItem = (item) => {
  //
  //   dispatch(updateFormInfo({ displayForm: true, formData: { item } }));
  // };

  return (
    <>
      {/* {showRequestForm && (
        <AddUpdateForm
          onSubmit={() => {
            onSubmit();
          }}
        />
      )} */}

      <main className="container-fluid dashboard">
        <div className="row m-3">
          <div className="row justify-content-around tble">
            <div className="col-6">
              <h3 className="dashboard-title">Branches</h3>
            </div>
            <div className="mr-auto col-6 text-end">
              <button
                type="button"
                className="mr-auto btn btn-purple-bg"
                onClick={
                  () => navigateStoreCreationPage()
                  // dispatch(
                  //   updateFormInfo({
                  //     displayForm: true,
                  //     formData: {},
                  //   })
                  // )
                }
              >
                + Add Branch
              </button>
            </div>
          </div>
        </div>

        <div className="row m-3">
          <div className="col-md-3">
            <div className="form-group">
              <label>Search Branch</label>
              <input
                type="search"
                name="name"
                className="form-control"
                value={searchVal}
                placeholder="Enter branch name"
                onChange={(e) => handleSearchClick(e)}
              />
            </div>
          </div>
          <div className="col-md-12 card-1 table-responsive">
            <table className="table-hover table table-striped table-bordered border-sm  mt-2">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">Id</th>
                  <th scope="col">Branch Name</th>
                  <th scope="col">Address</th>
                  <th scope="col" colSpan={3}>
                    Contact Details
                  </th>
                  <th scope="col">Serving radius</th>
                  <th scope="col">Delivey Charges</th>
                  <th scope="col">Min. Amount for Free Delivery</th>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                </tr>

                <tr>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col">Name</th>
                  <th scope="col">Phone</th>
                  <th scope="col">Mail</th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                </tr>
              </thead>
              {searchVal === "" && resultList && resultList.length > 0 ? (
                <tbody>
                  {resultList.map((item, i) => {
                    return <StoreItem item={item} key={item.id} />;
                  })}
                </tbody>
              ) : filterList.length > 0 ? (
                <tbody>
                  {filterList.map((item, i) => {
                    return <StoreItem item={item} key={item.id} />;
                  })}
                </tbody>
              ) : (
                <p>No Data found</p>
              )}
            </table>
          </div>
        </div>
      </main>
    </>
  );
}

export default Store;
